import React from "react";
import { connect } from "react-redux";

import { isSchoolsReady, getSchoolList } from "state/teachers/selectors";

import Spinner from "components/Spinner";
import SchoolLogo from "components/teachers/SchoolLogo";
import SchoolInfo from "components/app/info/SchoolInfo";

class TeachersSchoolList extends React.Component {
  
  render() {
    
    if (!this.props.isReady) {
      return (
        <div className="school-list__placeholder">
          <Spinner size="standalone" color="teachers" />
        </div>
      )
    }
    
    return this.props.schoolList.map(school => {
      const { id, name, websiteURL, phoneNumber, emailAddress } = school.toObject();
      const logo = <SchoolLogo school={school} cssBlockName="school-info" />;
      const props = { name, websiteURL, phoneNumber, emailAddress, logo };
      return (
        <SchoolInfo key={id} product="teachers" {...props} />
      )
    })
    
  }
  
}

export default connect(
  state => ({
    schoolList: getSchoolList(state),
    isReady: isSchoolsReady(state)
  })
)(TeachersSchoolList);



// WEBPACK FOOTER //
// ./src/components/app/info/TeachersSchoolList.js